// extracted by mini-css-extract-plugin
export default {"tabs":"m1-z","tablist":"n1-z","tablistItem":"o1-z"};